<template>
	<div class="main-content">
		<div class="top">
			<div class="search-cont">
				<div class="inp-search">
					<div class="details font-16 f-roman underline">
						<p @click="active = true">
							{{ $fn.tr("Detailed") }}
							<span class="font-16 f-roman underline">{{
								$fn.tr("Search")
							}}</span>
						</p>
						<div
							class="clear icon"
							v-if="active || search !== ''"
							@click="clearAll"
						>
							<svg
								xmlns="http://www.w3.org/2000/svg"
								width="15.27"
								height="15.27"
								viewBox="0 0 15.27 15.27"
							>
								<path
									id="Union_2"
									data-name="Union 2"
									d="M.736,15.207a1.365,1.365,0,0,1,0-1.93L6.042,7.972.735,2.665A1.364,1.364,0,0,1,2.664.736L7.971,6.043,13.277.736a1.365,1.365,0,0,1,1.93,1.931L9.9,7.973l5.305,5.305a1.364,1.364,0,1,1-1.929,1.929L7.972,9.9,2.666,15.207a1.365,1.365,0,0,1-1.93,0Z"
									transform="translate(-0.336 -0.337)"
									fill="#db504a"
								/>
							</svg>
						</div>
					</div>
					<input
						v-model="search"
						class="font-21 f-roman"
						type="text"
						:placeholder="$fn.tr('Type Keyword')"
					/>
				</div>
			</div>
			<slide-up-down :active="active" :duration="600">
				<div class="filters">
					<div v-if="statuses" class="select">
						<el-select :placeholder="$fn.tr('Status')" v-model="status">
							<el-option
								v-for="item in statuses"
								:value="item.id"
								:key="item.id"
								:label="item.title"
							>
							</el-option>
						</el-select>
					</div>

					<div v-if="types" class="select">
						<el-select :placeholder="$fn.tr('Types')" v-model="type">
							<el-option
								v-for="item in types"
								:value="item.id"
								:key="item.id"
								:label="item.title"
							>
							</el-option>
						</el-select>
					</div>

					<div v-if="formats" class="select">
						<el-select :placeholder="$fn.tr('Format')" v-model="format">
							<el-option
								v-for="item in formats"
								:value="item.id"
								:key="item.id"
								:label="item.title"
							>
							</el-option>
						</el-select>
					</div>

					<div v-if="formats" class="select">
						<el-select :placeholder="$fn.tr('Year')" v-model="year">
							<el-option
								v-for="item in years"
								:value="item"
								:key="item"
								:label="item"
							>
							</el-option>
						</el-select>
					</div>
				</div>
			</slide-up-down>

			<div class="statistics">
				<div class="list">
					<div class="item">
						{{ $fn.tr("ღონისძიება") }} <span>{{ totalEvents }}</span> -
						{{ $fn.tr("სასწავლო") }} <span>{{ totalLearning }}</span> /
						{{ $fn.tr("არასასწავლო") }} <span>{{ totalNonLearning }}</span
						>; {{ $fn.tr("ბენეფიციარი") }}
						<span>{{ totalBeneficiaries }}</span>
					</div>
				</div>

				<download-excel :data="ECXELData" class="download">
					{{ $fn.tr("ექსპორტი:") }}
					<svg
						width="32"
						height="30"
						viewBox="0 0 32 30"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							fill-rule="evenodd"
							clip-rule="evenodd"
							d="M28.781 4.12966H18.651V1.89185L2 4.30122V25.4203L18.651 28.109V24.7922H28.781C29.0878 24.8067 29.3883 24.7068 29.6167 24.5143C29.8451 24.3217 29.9829 24.0522 30 23.7647V5.15622C29.9827 4.86884 29.8448 4.59956 29.6164 4.40722C29.388 4.21487 29.0876 4.11508 28.781 4.12966ZM28.941 23.9353H18.617L18.6 22.1643H21.087V20.1018H18.581L18.569 18.8831H21.087V16.8206H18.55L18.538 15.6018H21.087V13.5393H18.53V12.3206H21.087V10.2581H18.53V9.03935H21.087V6.97685H18.53V5.10185H28.941V23.9353Z"
							fill="#20744A"
						/>
						<path
							d="M22.4871 6.97412H26.8101V9.03662H22.4871V6.97412ZM22.4871 10.2563H26.8101V12.3188H22.4871V10.2563ZM22.4871 13.5385H26.8101V15.601H22.4871V13.5385ZM22.4871 16.8207H26.8101V18.8832H22.4871V16.8207ZM22.4871 20.1029H26.8101V22.1654H22.4871V20.1029Z"
							fill="#20744A"
						/>
						<path
							fill-rule="evenodd"
							clip-rule="evenodd"
							d="M6.34709 10.0059L8.49309 9.89059L9.84209 13.3678L11.4361 9.74715L13.5821 9.63184L10.9761 14.5687L13.5821 19.5178L11.3131 19.3743L9.78109 15.6018L8.24809 19.2309L6.16309 19.0584L8.58509 14.6868L6.34709 10.0059Z"
							fill="white"
						/>
					</svg>
				</download-excel>
			</div>
		</div>
		<div class="items-list">
			<div class="inner">
				<div
					v-infinite-scroll="loadMore"
					infinite-scroll-disabled="busy"
					infinite-scroll-distance="10"
					:infinite-scroll-immediate-check="false"
				>
					<trainings_list_item
						v-for="item in finalData"
						:key="item.id"
						:item="item"
					/>
				</div>
			</div>
			<div class="arrow">
				<svg
					width="48"
					height="48"
					viewBox="0 0 48 48"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						d="M39.09 24.66C39.5113 25.0819 39.748 25.6537 39.748 26.25C39.748 26.8463 39.5113 27.4181 39.09 27.84L26.34 40.59C25.9181 41.0113 25.3462 41.248 24.75 41.248C24.1537 41.248 23.5818 41.0113 23.16 40.59L10.41 27.84C10.0127 27.4132 9.79642 26.8491 9.80649 26.2661C9.81656 25.6832 10.0522 25.1268 10.464 24.714C10.8768 24.3023 11.4331 24.0666 12.0161 24.0565C12.599 24.0465 13.1632 24.2628 13.59 24.66L22.5 33.57V11.25C22.5 10.6533 22.737 10.081 23.159 9.65901C23.5809 9.23705 24.1532 9 24.75 9C25.3467 9 25.919 9.23705 26.3409 9.65901C26.7629 10.081 27 10.6533 27 11.25V33.57L35.91 24.66C36.3318 24.2386 36.9037 24.002 37.5 24.002C38.0962 24.002 38.6681 24.2386 39.09 24.66Z"
						fill="#57A773"
					/>
				</svg>
			</div>
		</div>
	</div>
</template>

<script>
import trainings_list_item from "../list/trainings_list_item.vue";
import infiniteScroll from "vue-infinite-scroll";
export default {
	components: {
		trainings_list_item,
	},
	directives: { infiniteScroll },
	props: ["contentData"],
	data() {
		return {
			active: false,
			search: "",
			status: "",
			type: "",
			format: "",
			totalBeneficiaries: 0,
			totalEvents: 0,
			totalLearning: 0,
			totalNonLearning: 0,
			sliceIndex: 7,
			itemsLengt: 3,
			years: [],
			year: ''
		};
	},
	computed: {
		statuses() {
			return _.get(this.$store, "state.main.indx.terms.event_status");
		},
		types() {
			return _.get(this.$store, "state.main.indx.terms.event_types");
		},
		formats() {
			return _.get(this.$store, "state.main.indx.terms.event_formats");
		},
		ECXELData() {
			var res = [];
			this.listData?.forEach((item) => {
				res.push({
					title: _.get(item, "title"),
					date:
						this.formatDate(item?.event_date_from) +
						(item?.event_date_to
							? " - " + this.formatDate(item.event_date_to)
							: ""),
					type: this.getType(item),
					format: this.getFormat(item),
					target_group: _.get(item, "target_group"),
					number_of_beneficiaries: _.get(item, "number_of_beneficiaries"),
					description: _.get(item, "teaser"),
				});
			});
			return res;
		},
	  listData() {
      const dataList = _.get(this.contentData, "data.list", []);


      const withDate = dataList.filter(item => item.event_date_from);
      const withoutDate = dataList.filter(item => !item.event_date_from);

      withDate.sort((a, b) => new Date(b.event_date_from) - new Date(a.event_date_from));

      return [...withDate, ...withoutDate];
    },
		filteredData() {
			const result =  this.listData.filter((item) => {
				if (
					this.search &&
					!item.title.toLowerCase().includes(this.search.toLowerCase())
				) {
					return false;
				}

				if (this.type && !item.event_types?.includes(this.type)) {
					return false;
				}

				if (this.status && !item.event_status?.includes(this.status)) {
					return false;
				}

				if (this.format && !item.event_formats?.includes(this.format)) {
					return false; 
				}

				if (this.year && (new Date(item.event_date_from)).getFullYear() !== this.year) {
					return false;
				}

				return true;
			})
			if(this.search || this.format || this.status || this.type) result.sort(this.customDateComparator);
			return result
		},
		finalData() {
			return this.filteredData?.slice(0, this.sliceIndex);
		},
	},
	watch: {
		listData: {
			immediate: true,
			handler: function (value) {
				if (!value) return;
				const learningId =
					this.types?.find((item) => item.slug === "learning-events")
						?.id || null;
				const NonLearningId =
					this.types?.find((item) => item.slug === "non-learning")?.id ||
					null;
				const yearsSet = new Set();

				value.forEach((item) => {
					if (item.number_of_beneficiaries) {
						this.totalBeneficiaries =
							this.totalBeneficiaries +
							parseInt(item.number_of_beneficiaries);
					}
					if (item.event_types) {
						this.totalEvents++;
					}
					if (item.event_types?.includes(learningId)) {
						this.totalLearning++;
					}
					if (item.event_types?.includes(NonLearningId)) {
						this.totalNonLearning++;
					}
					if (item.event_date_from) {
						const year = (new Date(item.event_date_from)).getFullYear();
						year ? yearsSet.add(year) : '';
					}
				});

				this.years = Array.from(yearsSet).sort((a, b) => b - a);
			},
		},
	},
	methods: {
		getType(value) {
			const tmp = this.types?.filter((item) =>
				value?.event_types?.includes(item.id)
			);
			if (!tmp) return "";
			let result = "";
			tmp.forEach((type, index) => {
				result = result + (index ? " , " : "") + type.title;
			});
			return result;
		},
		getFormat(value) {
			const tmp = this.formats?.filter((item) =>
				value?.event_formats?.includes(item.id)
			);
			if (!tmp) return "";
			let result = "";
			tmp.forEach((type, index) => {
				result = result + (index ? " , " : "") + type.title;
			});
			return result;
		},
		clearAll() {
			this.search = "";
			this.active = false;
			this.type = "";
			this.format = "";
			this.status = "";
		},
		formatDate(date) {
			if (!date) return "";
			return date.replace(/-/g, "/");
		},
		loadMore() {
			if (this.sliceIndex >= this.filteredData.length) return;
			this.sliceIndex = Math.min(
				this.sliceIndex + this.itemsLengt,
				this.filteredData.length
			);
		},
		customDateComparator(event1, event2) {
			const isValidDate = (dateString) => {
				return !isNaN(new Date(dateString).getTime());
			};
			const date1 = event1.event_date_from;
			const date2 = event2.event_date_from;
			const isValidDate1 = isValidDate(date1);
			const isValidDate2 = isValidDate(date2);

			if (isValidDate1 && isValidDate2) { 
				return new Date(date2) - new Date(date1);
			}
			else if (isValidDate1) {
				return -1;
			} else if (isValidDate2) {
				return 1;
			}
			else {
				return 0;
			}
		}
	},
};
</script>

<style lang="scss" scoped>
.scroller {
	height: 200px;
	overflow: auto;
}
.main-content {
	padding: 55px 37px 34px 0;
	@media (max-width: 1599px) {
		& {
			padding: 55px 0 34px 0;
		}
	}
	@media (max-width: 1439px) {
		& {
			padding: 30px 0 34px;
		}
	}
	@media (max-width: 1365px) {
		& {
			padding: 0;
		}
	}
}

.top {
	padding: 56px 116px 56px 64px;
	background-color: var(--gray-bg);
	@media (max-width: 1599px) {
		& {
			padding: 56px;
		}
	}
	@media (max-width: 1023px) {
		& {
			padding: 21px;
		}
	}
	@media (max-width: 767px) {
		& {
			padding: 21px 16px;
		}
	}
}

.search-cont {
	display: flex;
	height: 80px;
	@media (max-width: 1023px) {
		height: 60px;
	}
	@media (max-width: 767px) {
		flex-direction: column;
		height: unset;
	}
}

.filters {
	padding-top: 20px;
	display: flex;

	.select {
		margin-right: 30px;
	}
	.select:last-child {
		margin-right: 0;
	}

	@media (max-width: 1023px) {
		& {
			flex-direction: column;
		}
		.select {
			width: 100%;
			margin-right: 0;
			margin-bottom: 16px;
		}
		.el-select {
			width: 100%;
		}
		.select:last-child {
			margin-bottom: 0;
		}
	}
}

.statistics {
	width: 100%;
	border-top: 1px solid #c8c9ca;
	border-bottom: 1px solid #c8c9ca;
	margin-top: 32px;
	padding: 29px 30px;

	display: flex;
	justify-content: space-between;
	align-items: center;

	.list {
		display: flex;
		flex-wrap: wrap;
		padding-right: 32px;
	}
	.item {
		font-size: 20px;

		span {
			color: var(--primary-txt);
			font-size: inherit;
		}
	}

	@media (max-width: 1023px) {
		padding: 16px 0;
		margin-top: 21px;

		.item {
			font-size: 16px;
		}
	}

	@media (max-width: 767px) {
		& {
			flex-direction: column;
			justify-content: flex-start;
			align-items: flex-start;
		}
		.list {
			padding-right: 0;
		}
	}
}

.download {
	flex: none;
	display: flex;
	align-items: center;
	font-size: 16px;
	color: #000000;
	text-decoration: underline;
	cursor: pointer;
	transition: 0.4s;
	&:hover {
		color: var(--primary-txt);
	}

	svg {
		margin-left: 12px;
	}
	@media (max-width: 767px) {
		margin-top: 16px;
		align-self: flex-end;
	}
}

.items-list {
	position: relative;
	margin-top: 46px;
	padding: 24px 40px 76px 64px;
	background-color: #f7f7f7;

	.inner {
		padding-bottom: 32px;
		padding-right: 65px;
		max-height: 735px;
		overflow: auto;
	}
	.inner::-webkit-scrollbar {
		width: 10px;
	}

	.inner::-webkit-scrollbar-track {
		background-color: #c8c9ca;
		border-radius: 10px;
	}

	.inner::-webkit-scrollbar-thumb {
		border-radius: 10px;
		background-color: #57a773;
	}

	@media (max-width: 1023px) {
		& {
			padding: 21px 16px 56px;
		}

		.inner {
			padding-right: 16px;
			padding-bottom: 21px;
		}
		.inner::-webkit-scrollbar {
			width: 5px;
		}
	}
}

.arrow {
	position: absolute;
	bottom: 28px;
	right: 96px;
	display: inline-flex;
	cursor: pointer;
	animation-duration: 2s;
	animation-name: anim;
	animation-iteration-count: infinite;
	@keyframes anim {
		0% {
			transform: translateY(0px);
		}
		50% {
			transform: translateY(-10px);
		}
		100% {
			transform: translateY(0px);
		}
	}

	@media (max-width: 1023px) {
		bottom: 6px;
		right: 32px;

		svg {
			width: 31px;
			height: auto;
		}
	}

	display: none;
}

.inp-search {
	position: relative;
	width: 100%;
	background: var(--white-bg);
	box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.05);
	@media (max-width: 767px) {
		width: 100%;
		height: 60px;
	}
	.details {
		position: absolute;
		top: 50%;
		transform: translateY(-50%);
		right: 30px;
		cursor: pointer;
		color: var(--bonus-txt);
		display: flex;
		z-index: 9;
		span {
			@media (max-width: 767px) {
				display: none;
			}
		}
		.icon {
			margin-left: 15px;
		}
		@media (max-width: 767px) {
			right: 16px;
			z-index: 9;
		}
	}
	&::after {
		content: "";
		position: absolute;
		left: 32px;
		top: 50%;
		transform: translateY(-50%);
		width: 2px;
		height: 25px;
		border-radius: 5px;
		background: var(--red);
	}
	@media (max-width: 767px) {
		&::after {
			left: 16px;
		}
	}
	input {
		position: absolute;
		top: 0;
		left: 56px;
		right: 56px;
		width: calc(100% - 280px);
		height: 100%;
		color: var(--bonus-txt);
		font-size: 21px;
		background: var(--white-bg);
		&::placeholder {
			opacity: 0.5;
			color: var(--bonus-txt);
		}
		@media (max-width: 1023px) {
			font-size: 16px;
		}
		@media (max-width: 767px) {
			left: 32px;
			right: 140px;
			width: auto;
		}
		@media (max-width: 480px) {
			left: 32px;
			right: 140px;
			width: auto;
		}
	}
}

// @media (max-width: 767px) {
// 	width: calc(100% - 185px);
// }
</style>

